export interface GetUserOfMemosAndNotesByIdRequest {
  id: string
}

export function GetUserOfMemosAndNotesByIdRequestToJSON(
  value: GetUserOfMemosAndNotesByIdRequest
): any {
  return {
    id: value.id !== '' ? value.id : undefined
  }
}

export const defaultGetUserOMemosAndNotesByIdRequest = (): GetUserOfMemosAndNotesByIdRequest => ({
  id: ''
})
